export default function Order (props) {
  const options = {
    year: 'numeric', month: 'numeric', day: 'numeric',
    hour: 'numeric', minute: 'numeric'
  };

  const self = {
    isCancelled: !!props.cancelled_at,
    isUnfulfilled: ['fulfilled', 'partial'].indexOf(props.fulfillment_status) == -1,
    isRefunded: props.financial_status == 'refunded',
    createdAtFormatted: new Intl.DateTimeFormat('en-US', options).format(new Date(props.created_at))
  }

  self.isInvalid = self.isCancelled || self.isUnfulfilled || self.isRefunded

  return Object.assign({}, props, self)
}
